module.exports = __webpack_public_path__ + "static/media/homeImg.8e0217ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homeImg.png
// module id = 1015
// module chunks = 0